"use client"

import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Advertising, Comment, Demand, Message, Reporting } from "@/savaradio/common"

export type NotificationType = "advertising" | "comment" | "reporting" | "message" | "demand"

export type NotificationPayload =
  | { type: "advertising", value: Advertising }
  | { type: "comment", value: Comment }
  | { type: "reporting", value: Reporting }
  | { type: "message", value: Message }
  | { type: "demand", value: Demand }

export type NotificationItem = NotificationPayload & { read: boolean }

type NotificationState = {
  value: NotificationItem[]
}

const initialState: NotificationState = {
  value: []
}

const notificationSlice = createSlice({
  name: "notification_slice",
  initialState,
  reducers: {
    push: (state, action: PayloadAction<NotificationPayload & { read?: boolean }>) => {
      const alreadyExist = state.value.some(
        item => item.type === action.payload.type && item.value._id === action.payload.value._id
      )
      if (!alreadyExist) state.value.push({ ...action.payload, read: action.payload.read ?? false })
    },
    pop: (state, action: PayloadAction<{ type: NotificationType, id: string }>) => {
      state.value = state.value.filter(
        item => !(item.type === action.payload.type && item.value._id === action.payload.id)
      )
    },
    markRead: (state, action: PayloadAction<{ type: NotificationType, id: string }>) => {
      state.value = state.value.map(item => {
        if (item.type === action.payload.type && item.value._id === action.payload.id) return { ...item, read: true }
        return item
      })
    },
    markManyRead: (state, action: PayloadAction<{ type: NotificationType, ids: string[] }>) => {
      const ids = new Set(action.payload.ids)
      state.value = state.value.map(item => {
        if (item.type === action.payload.type && ids.has(item.value._id)) return { ...item, read: true }
        return item
      })
    },
    reset: (state, action: PayloadAction<NotificationItem[] | undefined>) => {
      state.value = action.payload ?? []
    }
  }
})

export const { push, pop, reset, markRead, markManyRead } = notificationSlice.actions
export const notification_slice = notificationSlice.reducer
